import { render, staticRenderFns } from "./adband.vue?vue&type=template&id=1265c2a3&scoped=true"
import script from "./adband.vue?vue&type=script&lang=js"
export * from "./adband.vue?vue&type=script&lang=js"
import style0 from "./adband.vue?vue&type=style&index=0&id=1265c2a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1265c2a3",
  null
  
)

export default component.exports